import gql from 'graphql-tag';

const CREATE_REPORT = gql`
  mutation($input: ReportInput!) {
    createReport(input: $input) {
      reportId
      name
      description
      groupBy
      dataCondition
      reportType
      selectAttributes
      createdBy {
        userId
        name
        email
      }
      createdTime
      shareFilterCondition
      entity
      notificationTemplateId
      scheduleDefinition
    }
  }
`;

const UPDATE_REPORT = gql`
  mutation($reportId: ID!, $input: ReportInput!) {
    updateReport(reportId: $reportId, input: $input) {
      reportId
      name
      description
      groupBy
      entity
      dataCondition
      selectAttributes
      reportType
      createdBy {
        userId
        name
        email
      }
      createdTime
      shareFilterCondition
      notificationTemplateId
      scheduleDefinition
    }
  }
`;

export { CREATE_REPORT, UPDATE_REPORT };
